import { ConfigurationListSidePanelData, ConfigurationListSidePanelEntity, ConfigurationListSidepanelState, initialConfigurationListSidepanelState } from '@/modules/configurationModule/shared/components/configuration-list-sidepanel/configuration-list-sidepanel.model'
import { Vue, Component, Prop } from 'vue-property-decorator'

@Component({
})
export default class ConfigurationListSidepanel extends Vue {
    state: ConfigurationListSidepanelState
    @Prop({ default: false }) showBackdrop!: boolean
    @Prop({ default: true }) showRight!:boolean

    constructor() {
        super()
        this.state = initialConfigurationListSidepanelState()
    }

    get showEntitySelection(): boolean {
        return this.state.data.entities.length > 1
    }

    get entityAssociationSelected(): string {
        return this.$tc(this.state.selectedEntity?.entityKey!, this.state.values.length === 1 ? 1 : 2)
    }

    get titleSidepanel(): string {
        return this.state.data.title
    }

    getLocalizedEntity(entity: ConfigurationListSidePanelEntity): string {
        return this.$tc(entity.entityKey, 2) as string
    }

    public show(data:ConfigurationListSidePanelData, keepCurrentSelectedEntity:boolean = true): void {
        this.state.data = data
        if (!keepCurrentSelectedEntity || !this.state.selectedEntity) {
            this.state.selectedEntity = data.entities[0]
        }
        this.state.promise = this.loadEntities(this.state.selectedEntity)
        this.state.show = true
    }

    public hide(): void {
        this.state.show = false
    }

    _onChangeEntity(entity: ConfigurationListSidePanelEntity): void {
        this.state.promise = this.loadEntities(entity)
    }

    private async loadEntities(entity: ConfigurationListSidePanelEntity): Promise<void> {
        this.state.values = await this.state.data.obtainEntityList(entity)
    }
}
